import { useEffect, useState } from "react";

/**
 * Hook React détectant l'état en ligne / hors-ligne du navigateur.
 * Source de vérité: navigator.onLine + events 'online' / 'offline'.
 *
 * Usage:
 *   const online = useOnlineStatus();
 *   <button disabled={!online}>Envoyer</button>
 */
export default function useOnlineStatus() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true,
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return online;
}
